module.exports = __webpack_public_path__ + "static/media/festival_04.eb8be369.jpg";